import { legacyLogicalPropertiesTransformer } from 'ant-design-vue';
import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context';
import { globSetting } from '@mts/utils/env';

const { themeColor } = globSetting;

export const theme: ThemeConfig = {
  token: {
    colorPrimary: themeColor,
    colorSuccess: themeColor,
    colorWarning: '#FDAF00',
    colorError: '#FE5858',
    colorInfo: themeColor,
    colorTextDisabled: 'rgba(0, 0, 0, 0.65)',

    colorText: '#131A24',
    colorLink: themeColor,
    colorLinkHover: '#05C7A0',
    colorLinkActive: '#038C70',
    colorBgLayout: '#EBEDF0',

    fontSize: 14,
    borderRadius: 4,
    controlHeight: 30,
    colorBorder: '#D5D9E1',
    colorBorderSecondary: '#DFE5EC',
  },
  components: {
    Breadcrumb: {
      fontSize: 16,
      lineHeight: 1.5,
    },
    // Button: {
    //   fontSize: 18,
    //   fontSizeLG: 20,
    //   controlHeightSM: 36,
    //   controlHeightLG: 48,
    //   paddingContentHorizontal: 20,
    // },
  },
};

export const transformers = [legacyLogicalPropertiesTransformer];

export const defaultCardSize = 'small';
